// eslint-disable-next-line
import React, { lazy } from "react";
// eslint-disable-next-line
import PrivateRoute from "./PrivateRoute";
import { translate } from "./utils/i18n";
import Monitoring from "./views/Monitoring/Monitoring";
const Dashboard = lazy(() => import("./views/Dashboard"));
const DevicesIndex = lazy(() => import("./views/Devices/"));
const OrganizationsIndex = lazy(() => import("./views/Organizations/"));
const UsersIndex = lazy(() => import("./views/Users/"));
const MapPage = lazy(() => import("./views/Map/MapPage"));
const RolesIndex = lazy(() => import("./views/Roles"));
const Counters = lazy(() => import("./views/Counters/"));
const ServicesIndex = lazy(() => import("./views/orders/"));
const Firmware = lazy(() => import("./views/Firmware/Firmware"));
const ReleaseLog = lazy(() => import("./views/release/ReleaseLog"));
const CreateReleaseLog = lazy(() => import("./views/release/CreateReleaseLog"));

const breadcrumbs = [
  { path: "/", name: translate("breadcrumb.home"), exact: true },
  { path: "/dashboard", name: translate("breadcrumb.dashboard") },
  { path: "/devices", name: translate("breadcrumb.devices"), exact: true },
  { path: "/devices/new", name: translate("breadcrumb.newDevice"), exact: true },
  {
    path: "/devices/:deviceId",
    name: translate("breadcrumb.device"),
    exact: true,
  },
  {
    path: "/devices/:deviceId/edit",
    name: translate("breadcrumb.edit"),
    exact: true,
  },
  { path: "/devices/:deviceId/alerts", name: "Alerts", exact: true },
  {
    path: "/organizations",
    name: translate("breadcrumb.organizations"),
    exact: true,
  },
  {
    path: "/organizations/new",
    name: translate("breadcrumb.new"),
    exact: true,
  },
  {
    path: "/organizations/:orgId",
    name: translate("breadcrumb.organization"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/integrations",
    name: translate("breadcrumb.systemIntegrations"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/members",
    name: translate("breadcrumb.users"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/members/:userId",
    name: translate("breadcrumb.user"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/members/:userId/edit",
    name: translate("breadcrumb.edit"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/devices",
    name: translate("breadcrumb.devices"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/devices/:deviceId",
    name: translate("breadcrumb.device"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/devices/:deviceId/edit",
    name: translate("breadcrumb.edit"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/devices/:deviceId/alerts",
    name: "Alerts",
    exact: true,
  },
  {
    path: "/organizations/:orgId/contracts",
    name: translate("breadcrumb.contracts"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/contracts/:contractId",
    name: translate("breadcrumb.contract"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/roles",
    name: translate("breadcrumb.roles"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/keys",
    name: translate("breadcrumb.apiKeys"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/groups",
    name: translate("breadcrumb.groups"),
    exact: true,
  },
  {
    path: "/organizations/:orgId/audit",
    name: "Audit",
    exact: true,
  },
  { path: "/users", name: translate("breadcrumb.users"), exact: true },
  { path: "/users/:userId", name: translate("breadcrumb.user"), exact: true },
  {
    path: "/users/:userId/edit",
    name: translate("breadcrumb.edit"),
    exact: true,
  },
  { path: "/roles", name: translate("breadcrumb.roles"), exact: true },
  { path: "/roles/:roleId", name: translate("breadcrumb.role"), exact: true },
  { path: "/map", name: translate("breadcrumb.map"), exact: true },
  { path: "/services", name: translate("breadcrumb.services"), exact: true },
  { path: "/monitoring", name: "Monitoring ", exact: true },
  {
    path: "/orders/:view/new-order",
    name: translate("breadcrumb.newInstallationOrder"),
    exact: true,
  },
  {
    path: "/orders",
    name: translate("breadcrumb.orders"),
    exact: true,
  },
  {
    path: "/orders/installation",
    name: translate("breadcrumb.installations"),
    exact: true,
  },
  {
    path: "/orders/installation/:order_id",
    name: translate("breadcrumb.installationsOrderDetails"),
    exact: true,
  },

  {
    path: "/orders/installation/:order_id/install/:device_id",
    name: translate("breadcrumb.installDevice"),
    exact: true,
  },
  {
    path: "/orders/service-orders",
    name: translate("breadcrumb.serviceOrders"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/details",
    name: translate("breadcrumb.serviceDetails"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/edit",
    name: translate("breadcrumb.editServiceDetails"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard",
    name: translate("breadcrumb.serviceWizard"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard/info",
    name: translate("step.information"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard/before-service",
    name: translate("step.beforeService"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard/device-service",
    name: translate("step.service"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard/replacement",
    name: translate("step.replacement"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard/issue",
    name: translate("step.issue"),
    exact: true,
  },
  {
    path: "/orders/service-orders/:order_id/wizard/after-service",
    name: translate("step.afterService"),
    exact: true,
  },

  {
    path: "/orders/service-centers",
    name: translate("breadcrumb.serviceCenters"),
    exact: true,
  },
  {
    path: "/orders/service-centers/:service_center_id",
    name: translate("breadcrumb.serviceCenterDetails"),
    exact: true,
  },

  {
    path: "/orders/service-centers/:service_center_id/technicians/:technician_id",
    name: translate("breadcrumb.serviceCenterTechnicians"),
    exact: true,
  },
  {
    path: "/firmware",
    name: "Firmware",
    exact: true,
  },
  {
    path: "/release",
    name: "Release",
    exact: true,
  },
  {
    path: "/create-new-release",
    name: "CreateNewRelease",
    exact: true,
  },
];

const routes = [
  <PrivateRoute path="/dashboard" name="Dashboard" component={Dashboard} key="dashboard" />,
  <PrivateRoute path="/devices" name="Devices" component={DevicesIndex} key="devices" />,
  <PrivateRoute path="/organizations" name="Organizations" component={OrganizationsIndex} key="organizations" />,
  <PrivateRoute path="/users" name="Users" component={UsersIndex} key="users" />,
  <PrivateRoute path="/roles" name="Roles" component={RolesIndex} key="roles" />,
  <PrivateRoute path="/counters" name="Counters" component={Counters} key="counters" />,
  <PrivateRoute path="/map" name="Map" component={MapPage} key="map" />,
  <PrivateRoute path="/orders" name="Services" component={ServicesIndex} key="services" />,
  <PrivateRoute path="/firmware" name="Firmware" component={Firmware} key="firmware" />,
  <PrivateRoute path="/monitoring" name="Monitoring" component={Monitoring} key="monitoring" />,
  // <PrivateRoute path="/release" name="Release" component={ReleaseIndex} key="release" />,

  <PrivateRoute path="/release" name="Release" component={ReleaseLog} key="release" />,
  <PrivateRoute path="/create-new-release" name="CreateNewRelease" component={CreateReleaseLog} key="new-release" />,
];

export { routes, breadcrumbs };
